<template>
  <div
    class="bottomAdvertContainer"
    :style="{bottom: `${ this.bottomHeight}px`}"
    v-if="adData.length"
  >
    <div class="advertIMg">
      <img
        :src="adData[0].images"
        alt=""
        @click="onClickJump()"
      >
    </div>
  </div>
</template>

<script>
import { handleJumpType, homeGioAdClick } from '@/utils/tools';

export default {
  props: ['examYear', 'bottomadvertList', 'bottomAreaHeight'],
  data() {
    return {
      adData: [],
      bottomHeight: 0,
    };
  },
  watch: {
    bottomadvertList(val) {
      if (val?.length > 0) {
        val[0].adPosition_var = `${this.examYear}考研-首页-底部广告`;
        this.adData = new Array(val[0]);
      }
    },
    bottomAreaHeight(val) {
      if (val) {
        this.bottomHeight = +val;
      }
    },
  },
  mounted() {
  },
  methods: {
    onClickJump() {
      homeGioAdClick(this.adData); // gio
      handleJumpType(this, this.adData[0]);
    },
  },
};
</script>

<style lang="scss" scoped>
.bottomAdvertContainer {
  position: fixed;
  left: 0;
  // bottom: 110px;
  z-index: 99;
  width: 100%;
  height: 72px;
  // background: rgba(0, 0, 0, 0.5);
  text-align: center;

  img {
    width: 100%;
    height: 72px;
    // border-radius: 20px 20px 0px 0px;
    margin: 0 auto;
  }
}

.exambottom24 {
  bottom: 0 !important;
}
</style>
